import React, { useState } from 'react';
import { useSpring } from '@react-spring/web';
import Image, { StaticImageData } from 'next/image';
import VideoComponent, { VideoProps } from 'Components/Video';
import Modal from 'Components/Modal';

import { Button, ImageWrapper, IconWrapper, PlayIcon, Name } from './Bitesize.styled';

export interface Props {
    id: string;
    thumbnail: {
        src: string | StaticImageData;
        alt?: string;
        priority?: boolean;
    };
    video: VideoProps;
}

const Video: React.FC<Props> = ({ id, thumbnail, video }) => {
    const [isHovering, setIsHovering] = useState(false);
    const [isModalVisible, setModalVisible] = useState(false);

    const iconButtonSpring = useSpring({
        transform: isHovering ? 'scale(1.2)' : 'scale(1)',
        config: {
            mass: 2,
            tension: 200,
            friction: 20
        }
    });

    return (
        <>
            <Button
                tabIndex={0}
                onMouseOver={() => setIsHovering(true)}
                onMouseOut={() => setIsHovering(false)}
                data-hover={isHovering}
                aria-label={`Play video: ${video.title}`}
                onClick={() => setModalVisible(true)}
                className="button c-c-video-play"
            >
                <ImageWrapper>
                    <Image
                        src={thumbnail.src}
                        alt={thumbnail.alt ? thumbnail.alt : ''}
                        fill
                        style={{
                            objectFit: 'cover',
                            transform: isHovering ? 'scale(1.05)' : 'scale(1)',
                            transition: 'transform ease 0.6s'
                        }}
                        priority={thumbnail.priority}
                    />
                </ImageWrapper>
                <IconWrapper style={iconButtonSpring}>
                    <PlayIcon fill="currentColor" />
                </IconWrapper>
            </Button>
            <Name>{video.video.title}</Name>
            <Modal
                id={`m-clearing-video${id}`}
                heading={video.video.title}
                isVisible={isModalVisible}
                closeFnc={() => setModalVisible(false)}
                customWidth="70rem"
            >
                {video.image.src && (
                    <VideoComponent
                        {...video}
                        image={{
                            src: video.image.src,
                            alt: video.image.alt,
                            priority: true
                        }}
                    />
                )}
            </Modal>
        </>
    );
};

export default Video;
